import React from "react";
import {Link} from "react-router-dom";
import {listTarget} from "../utils/listMemory";

/**
 * A link back to a list (e.g. "← Ordens de serviço" on an order). It leads to
 * the list as it was last seen, with its filters, search, sorting and page, and
 * the list scrolls back to where it was.
 *
 * @param {{basePath: string, children: React.ReactNode}} props `basePath` is
 *   the list's own path, e.g. "/orders"
 */
const ListLink = ({basePath, children}) => {
    const {to, state} = listTarget(basePath);
    return (
        <Link to={to} state={state}>
            {children}
        </Link>
    );
};

export default ListLink;
